export default __webpack_public_path__ + "static/media/man.1416718a.svg";